import { Divider } from '@chakra-ui/react';
import CustomStepper from 'components/ui/custom-stepper/CustomStepper';
import StepperProvider, { useStepperContext } from 'components/ui/custom-stepper/CustomStepperContext';
import HeaderBarInternal from 'components/ui/HeaderBarInternal';
import { wrapperDialogDefaultProps } from 'features/emails/config';
import { useParams } from 'react-router-dom';
import ContentGroupForm from '../components/ContentGroupForm';

export default function PageCreateContentGroup() {
  const { type } = useParams();

  return (
    <StepperProvider
      steps={['Dados do Modelo', 'Categorias do Modelo']}
    >
      <HeaderBarInternal
        title="Novo Modelo de Disparo"
        backTo="/modelos-de-disparo"  
        dialogProps={wrapperDialogDefaultProps}
      >
        <CustomStepper />
      </HeaderBarInternal>
    
      <Divider />
      
      <CurrentStep />
    </StepperProvider>
  )
}


function CurrentStep() {
  const { type } = useParams();
  const { activeStep, previousStep, nextStep } = useStepperContext();
  
  if (activeStep === 0)
    return <ContentGroupForm type={type} />
  
  // if (activeStep === 1)
  //   return <CompanyRecipientsList onBack={previousStep} />;
  
  return null;
}